import { extractObjectValue } from '@teem/helpers/functions';

export const messages: any = {
	"drag_and_drop_file": $localize`:@@ts.common.drag_and_drop_file:Drag & Drop your files or Browse`,
	"exclusive_of_tax": $localize`:@@ts.common.exclusive_of_tax:Exclusive of Tax`,
	"inclusive_of_tax": $localize`:@@ts.common.inclusive_of_tax:Inclusive of Tax`,
	"not_applicable": $localize`:@@ts.common.not_applicable:Not Applicable`,
	"percentage": $localize`:@@ts.common.percentage:Percentage`,
	"amount": $localize`:@@ts.common.amount:Amount`,
	"fixed": $localize`:@@ts.common.fixed:Fixed`,
	"hourly": $localize`:@@ts.common.hourly:Hourly`,
	"new_account": $localize`:@@ts.common.new_account:New Account`,
	"existing_account": $localize`:@@ts.common.existing_account:Existing Account`,
	"month": $localize`:@@ts.common.month:Month`,
	"year": $localize`:@@ts.common.year:Year`,
	"ok": $localize`:@@ts.common.ok:Okay`,
	"yes": $localize`:@@ts.common.yes:Yes`,
	"no": $localize`:@@ts.common.no:No`,
	'cancel': $localize`:@@ts.common.cancel:Cancel`,
	'delete': $localize`:@@ts.common.delete:Delete`,
	'edit': $localize`:@@common.edit:Edit`,
	"no_cancel_it": $localize`:@@ts.common.no_cancel_it:No, cancel it!`,
	"done": $localize`:@@ts.common.done:Done!`,
	"verified": $localize`:@@ts.common.verified:VERIFIED!`,
	"not_verified": $localize`:@@ts.common.not_verified:Not Verified`,
	"alert": {
		'error': $localize`:@@ts.common.error:Error`,
		'success': $localize`:@@ts.common.success:Success`,
	},
	'address':{
		'added_successfully':$localize`:@@ts.address.added_successfully:Address added successfully`,
	},
	"warning": $localize`:@@ts.common.warning:Warning`,
	"saved": $localize`:@@ts.common.saved:Saved!`,
	"deleted": $localize`:@@ts.common.deleted:Deleted!`,
	//"sent": $localize`:@@ts.common.sent:Sent!`,
	"request_failed": $localize`:@@ts.common.request_failed:Request failed`,
	"something_went_wrong": $localize`:@@ts.common.something_went_wrong:Something gone wrong. Please contact to Admin`,
	"are_you_sure": $localize`:@@ts.common.are_you_sure:Are you sure?`,
	"you_want_to_update_status": $localize`:@@ts.common.you_want_to_update_status:You want to update status`,
	"status_updated_successfully": $localize`:@@ts.common.status_updated_successfully:Status updated successfully!`,
	"email_sent": $localize`:@@ts.common.email_sent:Email sent successfully!`,
	"pushed_to_fatoora": $localize`:@@ts.common.pushed_to_fatoora:Invoice pushed to Fatoora successfully!`,
	"message_sent": $localize`:@@ts.common.message_sent:Message sent successfully!`,
	"draft": $localize`:@@ts.draft:Draft`,
	"failed": $localize`:@@ts.failed:Failed`,
	"paid": $localize`:@@ts.paid:Paid`,
	"pending_confirmation": $localize`:@@ts.pending_confirmation:Pending Confirmation`,
	"partially": $localize`:@@ts.partially:Partially`,
	"unpaid": $localize`:@@ts.unpaid:Unpaid`,
	"refund": $localize`:@@ts.refund:Refund`,
	"refunded": $localize`:@@ts.refunded:Refunded`,
	"sent": $localize`:@@ts.sent:Sent`,
	"unsent": $localize`:@@ts.unsent:Unsent`,
	"viewed": $localize`:@@ts.viewed:Viewed`,
	"active": $localize`:@@ts.active:Active`,
	"inactive": $localize`:@@ts.inactive:InActive`,
	"approved": $localize`:@@ts.approved:Approved`,
	"accepted": $localize`:@@ts.accepted:Accepted`,
	"rejected": $localize`:@@ts.rejected:Rejected`,
	"reject": $localize`:@@ts.rejected:Reject`,
	"action": $localize`:@@ts.action:Action`,
	"na": $localize`:@@ts.na:N/A`,
	"pending": $localize`:@@ts.pending:Pending`,
	"canceled": $localize`:@@ts.canceled:Canceled`,
	"successful": $localize`:@@ts.successful:Successful`,
	"unsuccessful": $localize`:@@ts.unsuccessful:Unsuccessful`,
	"accept_quatation": $localize`:@@ts.accept_quatation:Accept Quatation`,
	"reject_resend": $localize`:@@ts.reject_resend:Reject & Resend`,
	"new": $localize`:@@ts.new:New`,
	"scheduled": $localize`:@@ts.scheduled:Scheduled`,
	"preparing": $localize`:@@ts.preparing:Preparing`,
	"ready_to_pickup": $localize`:@@ts.ready_to_pickup:Ready to pickup`,
	"picked_up": $localize`:@@ts.picked_up:Picked up`,
	"out_for_delivery": $localize`:@@ts.out_for_delivery:Out for delivery`,
	"completed": $localize`:@@ts.completed:Completed`,
	"declined": $localize`:@@ts.declined:Declined`,
	"request_declined": $localize`:@@ts.request_declined:Request declined`,
	"converted_to_invoice": $localize`:@@ts.converted_to_invoice:Converted to invoice`,
	"converted_to_quotation": $localize`:@@ts.converted_to_quotation:Converted to quotation`,
	"upcoming": $localize`:@@ts.upcoming:Upcoming`,
	"captain_assigned": $localize`:@@ts.captain_assigned:Captain assigned`,
	"captain_coming": $localize`:@@ts.captain_coming:Captain coming`,
	"captain_here": $localize`:@@ts.captain_here:Captain here`,
	"delivery_started": $localize`:@@ts.delivery_started:Delivery started`,
	"delivery_ended": $localize`:@@ts.delivery_ended:Delivery ended`,
	"courier_pending": $localize`:@@ts.courier_pending:Courier pending`,
	"collecting": $localize`:@@ts.collecting:Collecting`,
	"delivering": $localize`:@@ts.delivering:Delivering`,
	"drop_off_arrived": $localize`:@@ts.drop_off_arrived:Drop off arrived`,
	"dropoff_arrived": $localize`:@@ts.dropoff_arrived:Dropoff arrived`,
	"delivered": $localize`:@@ts.delivered:Delivered`,
	"expired": $localize`:@@ts.expired:Expired`,
	"via": $localize`:@@ts.via:Via`,
	"credit_card": $localize`:@@ts.credit_card:Credit card`,
	"credit-card": $localize`:@@ts.credit_card:Credit card`,
	"please_select_record_to_download": $localize`:@@ts.please_select_record_to_download:Please select record to download`,
	"are_you_sure_want_accept_quatation": $localize`:@@ts.common.are_you_sure_want_accept_quatation:Are you sure you want to accept this quotation`,
	"are_you_sure_want_reject_quatation": $localize`:@@ts.common.are_you_sure_want_reject_quatation:Are you sure you want to reject this quotation`,
	"are_you_sure_want_accept_order": $localize`:@@ts.common.are_you_sure_want_accept_order:Are you sure you want accept this Order and send an invoice`,
	"accept_order": $localize`:@@ts.common.accept_order:Accept Order`,
	"are_you_sure_want_reject_order": $localize`:@@ts.common.are_you_sure_want_reject_order:Are you sure you want reject this Order`,
	"reject_order": $localize`:@@orders.reject_order:Reject Order`,
	"enter_rejection_reason":$localize`:@@orders.enter_rejection_reason:Rejection reason`,
	"reason_required":$localize`:@@orders.reason_required:Rejection reason required`,
	"type_reason_here":$localize`:@@orders.type_reason_here:Enter rejection reason`,
	"verify_nafath": $localize`:@@ts.common.verify_nafath:Verify above nafath number`,
	"go_to_nafath_app": $localize`:@@ts.common.go_to_nafath_app:Go to nafath app and verify number`,
	"your_account_verified": $localize`:@@ts.common.your_account_verified:Your account already get verified`,
	"you_want_re_generate_nafath": $localize`:@@ts.common.you_want_re_generate_nafath:You want to re-generate nafath number`,
	"error": {
		"record_not_found": $localize`:@@ts.record_not_found:Record not found`,
		"cant_delete_invoice": $localize`:@@ts.error.cant_delete_invoice:You can't delete paid invoice`,
		"unable_to_update": $localize`:@@ts.unable_to_update:Unable to update record`,
		"unable_to_create": $localize`:@@ts.unable_to_create:Unable to create record`,
		"invalid_data": $localize`:@@ts.invalid_data:The given data was invalid`,
		"unable_to_save_payment_info": $localize`:@@ts.unable_to_save_payment_info:Unable to save payment information`,
		"unable_to_save_additional_info": $localize`:@@ts.unable_to_save_additional_info:Unable to save additional information`,
		"invalid_action": $localize`:@@ts.invalid_action:Invalid action,Please select valid action`,
		"select_one_more_record": $localize`:@@ts.select_one_more_record:Please select one or more record\'s`,
		"already_converted_to_invoice": $localize`:@@ts.already_converted_to_invoice:This record is already converted to invoice`,
		"can_not_convert_invoice_from_rejected_quote": $localize`:@@ts.can_not_convert_invoice_from_rejected_quote:You can not convert quotation record to invoice`,
		"can_not_convert_invoice_from_rejected_proposal": $localize`:@@ts.can_not_convert_invoice_from_rejected_proposal:You can not convert rejected proposal to invoice`,
		"select_client": $localize`:@@ts.error.select_client:Please select client`,
		"unable_to_select_plan": $localize`:@@ts.error.unable_to_select_plan:Unfortunately this action can only be done through admin. Please contact customer support`,
		"charge_in_process": $localize`:@@ts.error.charge_in_process:Your last request charge is being proceeded we will activate your account once your charge is succeeded`,
		'upgrade_account_to_create_more_invoice': $localize`:@@ts.upgrade_account_to_create_invoice:Please upgrade your account to create more Invoices.`,
		"add_online_payment_without_client_email": $localize`:@@ts.error.add_online_payment_without_client_email:This action can't be done because the invoice's client email address does not exist, so unable to send payment link.`,
		"unable_to_send_whatsapp_message": $localize`:@@ts.error.unable_to_send_whatsapp_message:Unable to send WhatsApp message.`,
		"account_not_verified": $localize`:@@ts.error.account_not_verified:Your Hala account has not been verified. Please contact a member of our support team to verify your account.`,
		"phone_number_is_not_registered": $localize`:@@ts.error.phone_number_is_not_registered:This number is not registered with Hala. Please enter the phone number you have registered with hala.`,
		"cant_delete_category": $localize`:@@ts.error.cant_delete_category:You can't delete this category`,
		"category_associated_with_product": $localize`:@@ts.error.category_associated_with_product:Category is associated with store products`,
		"category_associated_with_service": $localize`:@@ts.error.category_associated_with_service:Category is associated with store services`,
		"something_went_wrong":$localize`:@@ts.error.something_went_wrong: Something went wrong!`
	},
	"success": {
		"record_deleted_successfully": $localize`:@@ts.record_deleted_successfully:Record deleted successfully`,
		"tap_agreement_accepted_successfully": $localize`:@@ts.tap_agreement_accepted_successfully:Agreement accepted successfully`,
		"changes_saved_successfully":$localize`:@@ts.changes_saved_successfully:Changes saved successfully`
	},
	"dashboard": {
		"financial_goal_saved": $localize`:@@ts.dashboard.financial_goal_saved:Financial goals saved successfully`,
		"city_update_successfully": $localize`:@@ts.dashboard.city_update_successfully:City updated successfully`,
		"store_type_update_successfully": $localize`:@@ts.dashboard.store_type_update_successfully:Store type updated successfully`,
		"select_an_option" : $localize `:@@ts.dashboard.select_an_option:Select an option`,
		"last_week" : $localize `:@@ts.dashboard.last_week:Last week`,
		"this_week" : $localize `:@@ts.dashboard.this_week:This week`,
		"this_month" : $localize `:@@ts.dashboard.this_month:This month`,
		"today" : $localize `:@@ts.dashboard.today:Today`,
		"yesterday" : $localize `:@@ts.dashboard.yesterday:Yesterday`,
		"last_two_weeks" : $localize `:@@ts.dashboard.last_two_weeks:Last 2 weeks`,
		"last_month" : $localize `:@@ts.dashboard.last_month:Last month`,
		"last_three_month" : $localize `:@@ts.dashboard.last_three_month:Last 3 months`,
	},
	"client": {
		"client_name_updated": $localize`:@@ts.client_name_updated:Client name updated successfully`,
		"you_want_to_delete_client": $localize`:@@ts.you_want_to_delete_client:You want to delete client`,
		"client_deleted": $localize`:@@ts.client_deleted:Client account deleted successfully.`,
		"client_updated": $localize`:@@ts.client_updated:Client details updated successfully.`,
		"client_saved": $localize`:@@ts.client_saved:Client successfully saved.`,
		"send_invoice": $localize`:@@clients.send_invoice:Send Invoice`,
		"add_new_client": $localize`:@@clients.add_new_client:Add New Client`
	},
	"user": {
		"users": $localize`:@@ts.user.users:Users`,
		"user_saved": $localize`:@@ts.user.user_saved:User successfully saved.`,
		"you_want_to_delete_user": $localize`:@@ts.user.you_want_to_delete_user:You want to delete user.`,
		"user_deleted": $localize`:@@ts.user.user_deleted:User is successfully deleted!`,
		"users_deleted": $localize`:@@ts.user.users_deleted:Users successfully deleted!`,
		"user_updated": $localize`:@@ts.user_updated:User details updated successfully.`,
		"user": $localize`:@@ts.common.user:User`,
		"admin": $localize`:@@ts.common.admin:Admin`,
		"super_admin": $localize`:@@ts.common.super_admin:Super Admin`,
	},
	"invoice": {
		"invoice_saved": $localize`:@@ts.invoice_saved:Invoice successfully saved.`,
		"invoice_saved_and_whatsapp_sent": $localize`:@@ts.invoice_saved_and_whatsapp_sent:Invoice Whatsapped successfully and saved to all invoices`,
		"invoice_saved_and_email_sent": $localize`:@@ts.invoice_saved_and_email_sent:Invoice successfully saved and Email sent.`,
		"invoice_updated": $localize`:@@ts.invoice_updated:Invoice updated successfully`,
		"invoice_deleted": $localize`:@@ts.invoice_deleted:Invoice deleted successfully!`,
		"invoices_deleted": $localize`:@@ts.invoices_deleted:Invoices deleted successfully!`,
		"invoice_paid": $localize`:@@ts.invoice_paid:Invoice paid successfully!`,
		"invoice_marked_as_sent": $localize`:@@ts.invoice_marked_as_sent:Invoice marked as sent!`,
		"invoice_marked_as_viewed": $localize`:@@ts.invoice_marked_as_viewed:Invoice marked as viewed!`,
		"invoice_moved_to_all_invoices": $localize`:@@ts.invoice_moved_to_all_invoices:Invoices moved to All invoices!`,
		"payment_saved": $localize`:@@ts.payment_saved:Payment saved successfully.`,
		"please_add_deliverable": $localize`:@@ts.please_add_deliverable:Please add at least one deliverable`,
		"please_select_invoice": $localize`:@@ts.please_select_invoice:Please select invoice`,
		"please_select_draft": $localize`:@@ts.please_select_draft:Please select draft`,
		"you_want_to_delete_invoice": $localize`:@@ts.you_want_to_delete_invoice:You want to delete invoice.`,
		"you_want_to_cancel_invoice": $localize`:@@ts.you_want_to_cancel_invoice:You want to cancel invoice.`,
		'payment_link_copied': $localize`:@@ts.payment_link_copied:Payment link copied`,
		'invoice_copied_to_clipboard': $localize`:@@ts.invoice_copied_to_clipboard:Your invoice link has been copied to clipboard`,
		'upgrade_account_to_create_more_invoice': $localize`:@@ts.upgrade_account_to_create_invoice:Please upgrade your account to create more Invoices.`,
		"whatsapp_message_sent": $localize`:@@ts.invoice_whatsapp_message_sent:Invoice Whatsapped successfully`,
		"add_new_item": $localize`:@@ts.add_new_item:Add New Item`,
		"update_item": $localize`:@@ts.update_item:Update Item`,
		"record_payment": $localize`:@@ts.record_payment:Record Payment`,
		"confirm_payment": $localize`:@@ts.confirm_payment:Confirm Payment`,
		"you_want_to_resend_invoice_payment": $localize`:@@ts.you_want_to_resend_invoice_payment:You want to resend invoice payment.`,
		"resend_payment": $localize`:@@ts.resend_payment:Invoice payment resend successfully!`,
		"out_of_stock": $localize`:@@ts.out_of_stock:This item is out of stock, Please add qty in My Catalogue.`,
		"uncategorised": $localize`:@@ts.uncategorised:This item has now been added to your catalogue under 'uncategorised'.`,
		"you_want_to_pay_in_cash": $localize`:@@ts.you_want_to_pay_in_cash:You want to pay this in cash`,
		"you_cannot_redirect_to_payment_gateway_on_preview_mode": $localize`:@@ts.you_cannot_redirect_to_payment_gateway_on_preview_mode:You cannot be redirected to payment gateway on preview mode`,
		"credit_card_payments_will_be_hidden_as_a_payment_method_if_your_invoice_total_exceeds": $localize`:@@ts.credit_card_payments_will_be_hidden_as_a_payment_method_if_your_invoice_total_exceeds:Credit card payments will be not available as a payment method if your invoice total exceeds 20,000 SAR and less than 1 SAR`,
		"invoice_amount_reached": $localize`:@@ts.invoice_amount_reached:Error! Minimum amount should be 5 Sr`,
		"invoice_amount_must_be_greater_than_zero": $localize`:@@ts.invoice_amount_must_be_greater_than_zero:Invoice amount must be greater than zero`,
		"tap_invoice_amount_reached": $localize`:@@ts.tap_invoice_amount_reached:Error! Minimum amount should be 1 Sr`,
		"you_want_to_update_invoice": $localize`:@@ts.you_want_to_update_invoice:You want to refund the amount`,
		"you_want_to_update_invoice_recovered_from_next_online_invoice_payment": $localize`:@@ts.you_want_to_update_invoice_recovered_from_next_online_invoice_payment:You want to refund the amount; it will be recovered from the next online invoice payment.`,
    	'make_a_refund': $localize`:@@ts.make_a_refund:Make a Refund`,
    	'make_a_online_refund': $localize`:@@ts.make_a_online_refund:Make a Online Refund`,
    	'save_as_invoice': $localize`:@@ts.save_as_invoice:Save as Invoice`,
    	'download_pdf': $localize`:@@invoices.download_pdf:PDF Download`,
    	'download_xml': $localize`:@@invoices.download_xml:XML Download`,
    	'send_via_email': $localize`:@@invoices.send_via_email:Send via Email`,
    	'cancel_invoice': $localize`:@@invoices.cancel_invoice:Cancel Invoice`,
    	'send_via_whatsapp': $localize`:@@invoices.send_via_whatsapp:Send via Whatsapp`,
    	'copy_link': $localize`:@@invoices.copy_link:Copy Link`,
    	'invoice_min_max_amount_pop_up_message': $localize`:@@ts.invoice_min_max_amount_pop_up_message:Please note that invoice value must be between 1 and 20,000`,
		'confirm_refund': $localize`:@@invoices.confirm_refund:Confirm Refund`,
		'proceed_with_refund_confirmation': $localize`:@@invoices.proceed_with_refund_confirmation:To proceed with the refund, please type <b>REFUND</b>. The refunded amount will be recovered from the next online invoice payment.`,
		'type_refund_confirm': $localize`:@@invoices.type_refund_confirm:Type REFUND to confirm`,
		'you_must_type_refund_to_proceed': $localize`:@@invoices.you_must_type_refund_to_proceed:You must type REFUND to proceed`,
		'proceed': $localize`:@@invoices.proceed:Proceed`
	},
	"expense": {
		"expense_saved": $localize`:@@ts.expense_saved:Expense saved successfully.`,
		"expense_updated": $localize`:@@ts.expense_updated:Expense updated successfully.`,
		"expense_deleted": $localize`:@@ts.expense_deleted:Expense deleted successfully.`,
		"expense_refunded": $localize`:@@ts.expense_refunded:Expense refunded successfully.`,
		"you_want_to_refund_expense": $localize`:@@ts.you_want_to_refund_expense:You want to refund this expense`,
		"you_want_to_delete_expense": $localize`:@@ts.you_want_to_delete_expense:You want to delete this expense`
	},
	"profile": {
		"you_want_to_delete_address": $localize`:@@ts.you_want_to_delete_address:You want to delete this address`,
		"deleted_address": $localize`:@@ts.deleted_address:You want to delete this address`,
	},
	"quote": {
		"please_add_deliverable": $localize`:@@ts.quote.please_add_deliverable:Please add at least one deliverable`,
		"quote_saved": $localize`:@@ts.quote.quote_saved:Quotation successfully saved.`,
		"draft_converted_to_quote": $localize`:@@ts.quote.draft_converted_to_quote:Quotation moved to All quotations!`,
		"quote_saved_and_whatsapp": $localize`:@@ts.quote.quote_saved_and_whatsapp:Quotation successfully saved and Whatsapp message sent.`,
		"quote_copied_to_clipboard": $localize`:@@ts.quote.quote_copied_to_clipboard:Your quotation link has been copied to clipboard.`,
		"quote_saved_and_email": $localize`:@@ts.quote.quote_saved_and_email:Quotation successfully saved and Email sent.`,
		"please_select_quote": $localize`:@@ts.quote.please_select_quote:Please select quotation`,
		"please_select_draft": $localize`:@@ts.quote.please_select_draft:Please select draft`,
		"you_want_to_delete_quotation": $localize`:@@ts.quote.you_want_to_delete_quotation:You want to delete quotation.`,
		"quote_deleted": $localize`:@@ts.quote.quote_deleted:Quotation is successfully deleted!`,
		"quotes_deleted": $localize`:@@ts.quote.quotes_deleted:Quotations successfully deleted!`,
		"marked_as_sent": $localize`:@@ts.quote.marked_as_sent:Quotation marked as sent!`,
		"marked_as_viewed": $localize`:@@ts.quote.marked_as_viewed:Quotation marked as viewed!`,
		"marked_as_approved": $localize`:@@ts.quote.marked_as_approved:Quotation marked as approved!`,
		"marked_as_rejected": $localize`:@@ts.quote.marked_as_rejected:Quotation marked as rejected!`,
		"converted_to_invoice": $localize`:@@ts.quote.converted_to_invoice:Quotation converted to invoice!`,
		"quote_converted_to_invoice": $localize`:@@ts.quote.quote_converted_to_invoice:Converted to invoice`,
		"edit_resend": $localize`:@@ts.quote.edit_resend:Edit and Resend`,
		"convert_to_invoice": $localize`:@@ts.quote.convert_to_invoice:Convert to invoice`
	},
	"proposal": {
		"proposal_saved": $localize`:@@ts.proposal.proposal_saved:Proposal successfully saved`,
		"proposal_updated": $localize`:@@ts.proposal.proposal_updated:Proposal updated successfully`,
		"proposal_deleted": $localize`:@@ts.proposal.proposal_deleted:Proposal is successfully deleted.`,
		"proposals_deleted": $localize`:@@ts.proposal.proposals_deleted:Proposals successfully deleted.`,
		"proposal_saved_and_whatsapp": $localize`:@@ts.proposal.proposal_saved_and_whatsapp:Proposal successfully saved and Whatsapp message sent.`,
		"proposal_saved_and_email": $localize`:@@ts.proposal.proposal_saved_and_email:Proposal successfully saved and Email sent.`,
		"please_add_deliverable": $localize`:@@ts.proposal.please_add_deliverable:Please add at least one deliverable`,
		"please_select_proposal": $localize`:@@ts.proposal.please_select_proposal:Please select proposal`,
		"please_select_draft": $localize`:@@ts.proposal.please_select_draft:please select draft`,
		"marked_as_sent": $localize`:@@ts.proposal.marked_as_sent:Proposal marked as sent!`,
		"marked_as_viewed": $localize`:@@ts.proposal.marked_as_viewed:Proposal marked as viewed!`,
		"marked_as_approved": $localize`:@@ts.proposal.marked_as_approved:Proposal marked as approved!`,
		"marked_as_rejected": $localize`:@@ts.proposal.marked_as_rejected:Proposal marked as rejected!`,
		"default_terms_saved": $localize`:@@ts.proposal.default_terms_saved:Default terms and conditions is successfully saved.`,
		"please_select_terms": $localize`:@@ts.proposal.please_select_terms:Please select atleast one term & condition`,
		"you_want_to_delete_proposal": $localize`:@@ts.proposal.you_want_delete_proposal:You want to delete proposal.`,
		"converted_to_invoice": $localize`:@@ts.proposal.converted_to_invoice:Proposal has been converted to invoice successfully`
	},
	"billing": {
		"auto_renew": $localize`:@@ts.billing.auto_renew:Auto Renew turn off successfully.`,
		"auto_renew_on": $localize`:@@ts.billing.auto_renew:Auto Renew turn On successfully.`,
		"stop_auto_renew": $localize`:@@ts.billing.stop_auto_renew:You would like to stop your membership`,
		"cancel_auto_renew_off": $localize`:@@ts.billing.cancel_auto_renew_off:You would like to resume your membership`,
		'credit_card_number': $localize`:@@ts.billing.credit_card_number:Card Number`, // 'رقم البطاقة الإئتمانية',
		'cvv': $localize`:@@ts.billing.cvv:CVV`, //' رمز الأمان CVV',
		'card_holder_name': $localize`:@@ts.billing.card_holder_name:Card Holder Name`, //'إسم صاحب البطاقة',
		'card_detail_updated': $localize`:@@ts.billing.card_detail_updated:Card Detail has been updated successfully`
	},
	"setting": {
		"information_updated": $localize`:@@ts.information_updated:Information updated successfully.`,
		"general_information_updated": $localize`:@@ts.setting.general_information_updated:General information has been saved successfully.`,
		"color_palette_updated": $localize`:@@ts.setting.color_palette_updated:Colour palette has been updated successfully.`,
		"business_information_updated": $localize`:@@ts.setting.business_information_updated:Business information has been saved successfully.`,
		"merchant_information_updated": $localize`:@@ts.setting.merchant_information_updated:Merchant details have been saved successfully.`,
		"halala_information_updated": $localize`:@@ts.setting.halala_information_updated:Your Hala Account has now been Linked with your Teem account. Happy Invoicing!`,
		"remove_hala_number_confirm": $localize`:@@ts.setting.remove_hala_number_confirm:You want to remove Hala mobile number?`,
		"remove_hala_number_success": $localize`:@@ts.setting.remove_hala_number_success:Hala mobile number has been removed successfully`,
		"stcpay_merchant_added": $localize`:@@ts.setting.stcpay_merchant_added:Thank you for entering your STC Pay merchant ID, your ID will be manually reviewed by our admin team and you will be notified via email once your STC Pay account has been approved activated.`,
		"tamara_added": $localize`:@@ts.setting.tamara_added:Tamara access token added successfully.`,
		"remove_stcpay_merchant_confirm": $localize`:@@ts.setting.remove_stcpay_merchant_confirm:Do you want to unlink your STC Pay merchant Account?`,
		"remove_tamara_confirm": $localize`:@@ts.setting.remove_tamara_confirm:Do you want to unlink your Tamara Account?`,
		"remove_stcpay_merchant_success": $localize`:@@ts.setting.remove_stcpay_merchant_success:STC Pay merchant ID has been unlinked successfully`,
		"remove_tamara_success": $localize`:@@ts.setting.remove_tamara_success:Tamara access token ID has been unlinked successfully`,
		"remove_paypal_merchant_confirm": $localize`:@@ts.setting.remove_paypal_merchant_confirm:Do you want to unlink your Payapl merchant Account?`,
		"remove_paypal_merchant_success": $localize`:@@ts.setting.remove_paypal_merchant_success:Payapl merchant ID has been unlinked successfully`,
    	"momkn_merchant_added": $localize`:@@ts.setting.momkn_merchant_added:Your Momkn Account has now been Linked with your Teem account. Happy Invoicing!`,
	  	"momkn_merchant_request": $localize`:@@ts.setting.momkn_merchant_request:Thank you for entering your Momkn merchant ID, your ID will be manually reviewed by our admin team and you will be notified via email once your Momkn account has been approved or activated.`,

    	"remove_momkn_merchant_confirm": $localize`:@@ts.setting.remove_momkn_merchant_confirm:Do you want to unlink your Momkn merchant Account?`,
    	"remove_momkn_merchant_success": $localize`:@@ts.setting.remove_momkn_merchant_success:Momkn merchant ID has been unlinked successfully`,
		"stop_auto_renew": $localize`:@@ts.billing.stop_auto_renew:You would like to stop your membership`,
		"subscription_updated": $localize`:@@ts.setting.subscription_updated:Your subscription has been updated.`,
		"downgrade_plan_confirm": $localize`:@@ts.setting.downgrade_plan_confirm:You want to downgrade plan`,
		"upgrade_plan_confirm": $localize`:@@ts.setting.upgrade_plan_confirm:Currently, Teem’s Professional/Business package only supports business owners with Bank accounts located in Saudi Arabia. Please stay posted for any updates`,
		"i_am_based_in_saudi_arabia": $localize`:@@ts.setting.i_am_based_in_saudi_arabia:I am based in Saudi Arabia`,
		"based_outside_saudi_arabia": $localize`:@@ts.setting.based_outside_saudi_arabia:Based outside Saudi Arabia?`,
		"select_appropriate_image_size": $localize`:@@ts.setting.select_appropriate_image_size:Please select image in 175 X 125 size`,
		"you_want_to_delete_logo": $localize`:@@ts.setting.delete_logo_confirm:You want to delete Logo.`,
		"subscription_request_submitted": $localize`:@@ts.setting.subscription_request_submitted:Your subscription has been updated successfully, this may take a few minutes to update`,
		"subscription_upgrade_submitted": $localize`:@@ts.setting.subscription_upgrade_submitted:A payment link has been sent to your email address. Please complete the payment process to update your subscription.`,
		"subscription_downgrade_submitted": $localize`:@@ts.setting.subscription_downgrade_submitted:Subscription request has been submitted. Your plan will be updated on end of current plan.`,
		'online_payment_not_available_for_country': $localize`:@@ts.setting.online_payment_not_available_for_country:Online payments are not available for the selected country and your Hala account will be disconnected from the Teem app.`,
		"resume_subscription_to_downgrade_plan": $localize`:@@ts.setting.resume_subscription_to_downgrade_plan:Please resume your subscription to downgrade your plan`,
		"resume_subscription_to_upgrade_plan": $localize`:@@ts.setting.resume_subscription_to_upgrade_plan:Please resume your subscription to upgrade your plan`,
		"you_cannot_upgrade_package": $localize`:@@ts.setting.you_cannot_upgrade_package:You cannot upgrade package, please contact system administrator.`,
		"terminate_your_account": $localize`:@@ts.setting.terminate_your_account:You want to terminate your account`,
	},
	"taxes": {
		"input_tax_updated": $localize`:@@ts.input_tax_updated:Input Tax updated successfully.`,
		"tax_saved": $localize`:@@ts.tax_saved:Tax successfully saved.`
	},
	"order": {
		"marked_as_accepted": $localize`:@@ts.order.marked_as_approved:Order has been accepted!`,
		"marked_as_rejected": $localize`:@@ts.order.marked_as_rejected:Order has been rejected!`,
		"marked_as_declined": $localize`:@@ts.order.marked_as_rejected:Order has been declined!`,
		"marked_as_canceled": $localize`:@@ts.order.marked_as_canceled:Order has been canceled!`,
		"you_want_update_status": $localize`:@@ts.you_want_update_status:You want to update status!`,
		"delete_order": $localize`:@@ts.order.delete_order:Yes, Delete Order`,
		"cancel_order": $localize`:@@ts.order.cancel_order:Cancel Order`,
		"are_you_sure_want_delete_order": $localize`:@@ts.order.are_you_sure_want_delete_order:Are you sure you want to delete this order`,
		"are_you_sure_want_cancel_order": $localize`:@@ts.order.are_you_sure_want_cancel_order:Are you sure you want to cancel this order`,
		'address_copied_to_clipboard': $localize`:@@ts.address_copied_to_clipboard:Address has been copied to clipboard`,
		'order_number': $localize`:@@ts.order_number:Order Number`,
		'customer_info': $localize`:@@ts.customer_info:Customer Info`,
		'delivery_info': $localize`:@@ts.customer_info:Delivery Info`,
		'location': $localize`:@@ts.location:Location`,
		'location_attachment': $localize`:@@ts.location_attachment:Location Attachment`,
		'update_status': $localize`:@@ts.update_status:Update status`,
		'order_status_updated': $localize`:@@ts.order_status_updated:Order status updated`,
	},
	"store": {
		'you_want_to_disconnect_foodics': $localize`:@@ts.store.you_want_to_disconnect_foodics:You want to disconnect foodics account.`,
		'delete_cover_image_confirm': $localize`:@@ts.store.delete_cover_image_confirm:You want to delete store cover image.`,
		'updated': $localize`:@@ts.store.updated:Store information updated.`,
		'you_want_to_apply_branch': $localize`:@@branch.have_branch:Do you have more than one branch`,
		'you_want_to_deactivate_branch': $localize`:@@branch.deactivate_branch:Do you want to deactivate branch`, 
		'store_url_copied_to_clipboard': $localize`:@@branch.store_url_copied_to_clipboard:Store URL has been copied to clipboard`,
	},
	"branch_template":{
		'updated': $localize`:@@ts.branch_template.updated:Branch template information updated.`
	},
	"branch":{
		'updated': $localize`:@@ts.branch.updated:Branch information updated.`,
		'created': $localize`:@@ts.branch.created:Branch created successfully.`
	},
	"product": {
		'delete_image_confirm': $localize`:@@ts.product.delete_image_confirm:You want to delete product image.`,
		'you_want_to_delete_product': $localize`:@@ts.product.you_want_to_delete_product:You want to delete this product.`,
		'added': $localize`:@@ts.product.added:Product added successfully.`,
		'updated': $localize`:@@ts.product.updated:Product updated successfully.`,
		'deleted': $localize`:@@ts.product.deleted:Product deleted successfully.`,
		'add_category':$localize`:@@store.add_category:Add Category`
	},
	"payment": {
		'update_to_accept': $localize`:@@ts.payment.update_to_accept:You would like to confirm receiving the payment`,
		'update_successfully': $localize`:@@ts.payment.update_successfully:Payment status updated successfully`,
		'update_to_reject': $localize`:@@ts.payment.update_to_reject:You would like to reject receiving the payment`,
		'deleted_successfully': $localize`:@@ts.payment.deleted_successfully:Payment deleted successfully`
	},
	"service": {
    'you_want_to_delete_service': $localize`:@@ts.service.you_want_to_delete_service:You want to delete service.`,
    'added': $localize`:@@ts.service.added:Service added successfully.`,
		'updated': $localize`:@@ts.service.updated:Service updated successfully.`,
		'deleted': $localize`:@@ts.service.deleted:Service deleted successfully.`,
	},
	"hyperpay": {
		'thank_you_for_entering_your_application': $localize`:@@ts.hyperpay.thank_you_for_entering_your_application:Thank you for submitting your application for online payments activation. Your application is being reviewed and you will be notified once approved to complete the process! `,
		'your_request_has_been_sent': $localize`:@@ts.hyperpay.your_request_has_been_sent:Your request has been sent`,
		'your_can_now_receive_online_payments': $localize`:@@ts.hyperpay.your_can_now_receive_online_payments:Your can now receive online payments on your Teem invoices &#129395; `,
		'you_can_now_offer_your_customers_payment_using': $localize`:@@ts.hyperpay.you_can_now_offer_your_customers_payment_using:You can now offer your customers payment using Mada, Apple Pay, Mastercard and Visa. All received payments will then be automatically transferred into your bank account.`,
	},
	"tap": {
		'you_want_update_tap_business_info': $localize`:@@ts.tap.you_want_update_tap_business_info: You want to update your TAP business account info`,
		'admin_get_touch_with_you_soon': $localize`:@@ts.tap.admin_get_touch_with_you_soon:Admin will get in touch with you soon`,
		"tap_agreement_rejected": $localize`:@@ts.tap.tap_agreement_rejected:Tap account deactivated successfully`,
		"you_want_deactivated_account": $localize`:@@ts.tap.you_want_deactivated_account:You want to deactivated your account`
	},
	"subscription": {
		'invoicing': $localize`:@@ts.subscription.invoicing: Invoicing`,
		'online_store': $localize`:@@ts.subscription.online_store: Online Store`,
		'online_ordering': $localize`:@@ts.subscription.online_ordering: Online Ordering`,
		'complete_solution': $localize`:@@ts.subscription.complete_solution: Complete Solution`,
	},
	"plan": {
		"invoice_basic_plan": $localize`:@@ts.plan.invoice_basic_plan: Invoice Basic Plan`,
		"invoice_pro_plan": $localize`:@@ts.plan.invoice_pro_plan: Invoice Pro Plan`,
		"invoice_enterprise_plan": $localize`:@@ts.plan.invoice_enterprise_plan: Invoice Enterprise Plan`,
		"online_store_basic_plan": $localize`:@@ts.plan.online_store_basic_plan: Online Store Basic Plan`,
		"online_store_pro_plan": $localize`:@@ts.plan.online_store_pro_plan: Online Store Pro Plan`,
		"online_store_enterprise_plan": $localize`:@@ts.plan.online_store_enterprise_plan: Online Store Enterprise Plan`,
		"online_ordering_basic_plan": $localize`:@@ts.plan.online_ordering_basic_plan: Online Ordering Basic Plan`,
		"online_ordering_pro_plan": $localize`:@@ts.plan.online_ordering_pro_plan: Online Ordering Pro Plan`,
		"online_ordering_enterprise_plan": $localize`:@@ts.plan.online_ordering_enterprise_plan: Online Ordering Enterprise Plan`,
		"complete_solution_plan": $localize`:@@ts.plan.complete_solution_plan: Complete Solution Plan`,
		"individual_plan": $localize`:@@ts.plan.individual_plan: Individual Plan`,
		"professional_plan": $localize`:@@ts.plan.professional_plan: Professional Plan`,
		"business_plan": $localize`:@@ts.plan.business_plan: Business Plan`,
		"invoicing": {
			'ksa_vat_compliant_invoices': $localize`:@@ts.plan.features.ksa_vat_compliant_invoices: KSA VAT-compliant invoices`,
			'unlimited_clients': $localize`:@@ts.plan.features.unlimited_clients: Unlimited Clients`,
			'quotes_and_estimates': $localize`:@@ts.plan.features.quotes_and_estimates: Quotes & estimates`,
			'invoice_via_email': $localize`:@@ts.plan.features.invoice_via_email: Invoice via email`,
			'invoice_via_whatsapp': $localize`:@@ts.plan.features.invoice_via_whatsapp: Invoice via WhatsApp`,
			'multiple_billing_addresses': $localize`:@@ts.plan.features.multiple_billing_addresses: Multiple billing addresses`,
			'multiple_bank_accounts': $localize`:@@ts.plan.features.multiple_bank_accounts: Multiple bank accounts`,
			'accept_online_payments': $localize`:@@ts.plan.features.accept_online_payments: Accept online payments`,
			'bill_in_any_currency': $localize`:@@ts.plan.features.bill_in_any_currency: Bill in any currency`,
			'expense_management': $localize`:@@ts.plan.features.expense_management: Expense management`,
			'itemized_invoices': $localize`:@@ts.plan.features.itemized_invoices: Itemized invoices (Coming Soon)`,
			'branding': $localize`:@@ts.plan.features.branding: Branding (Coming Soon)`,
			'b2b_invoices': $localize`:@@ts.plan.features.b2b_invoices: B2B invoices`,
			'client_reports': $localize`:@@ts.plan.features.client_reports: Client reports (Coming Soon)`,
			'sales_reports': $localize`:@@ts.plan.features.sales_reports: Sales reports (Coming Soon)`,		
			'recurring_invoices': $localize`:@@ts.plan.features.recurring_invoices: Recurring invoices (Coming Soon)`,
			'payment_reminders': $localize`:@@ts.plan.features.payment_reminders: Payment reminders (Coming Soon)`
		},
		"complete_solution": {
			'dedicated_storefront': $localize`:@@ts.plan.features.dedicated_storefront: Dedicated Storefront`,
			'unlimited_product_listings': $localize`:@@ts.plan.features.unlimited_product_listings: Unlimited Product Listings`,
			'unlimited_orders': $localize`:@@ts.plan.features.unlimited_orders: Unlimited Orders`,
			'no_selling_fees': $localize`:@@ts.plan.features.no_selling_fees: No Selling Fees`,
			'all_product_types': $localize`:@@ts.plan.features.all_product_types: All Product Types`,
			'accept_online_payments': $localize`:@@ts.plan.features.accept_online_payments: Accept Online Payments`,
			'pick_up_orders': $localize`:@@ts.plan.features.pick_up_orders: Pick Up Orders`,
			'order_management': $localize`:@@ts.plan.features.order_management: Order Management`,
			'order_approval_option': $localize`:@@ts.plan.features.order_approval_option: Order Approval Option`,
			'inventory_management': $localize`:@@ts.plan.features.inventory_management: Inventory Management`,
			'foodics_sync': $localize`:@@ts.plan.features.foodics_sync: Foodics Sync`,
			'vat_collection': $localize`:@@ts.plan.features.vat_collection: VAT Collection`,
			'all_delivery_partners': $localize`:@@ts.plan.features.all_delivery_partners: All Delivery Partners`,
			'all_payment_partners': $localize`:@@ts.plan.features.all_payment_partners: All Payment Partners`,
			'custom_delivery_option': $localize`:@@ts.plan.features.custom_delivery_option: Custom delivery option`,
			'instant_checkout': $localize`:@@ts.plan.features.instant_checkout: Instant checkout`,
			'promo_codes': $localize`:@@ts.plan.features.promo_codes: Promo codes`,
			'delivery_discounts': $localize`:@@ts.plan.features.delivery_discounts: Delivery discounts`,
			'sales_reports_and_analytics': $localize`:@@ts.plan.features.sales_reports_and_analytics: Sales reports and analytics (Coming Soon)`,
			'custom_domain': $localize`:@@ts.plan.features.custom_domain: Custom domain (Coming Soon)`,
			'custom_store_design': $localize`:@@ts.plan.features.custom_store_design: Custom store design (Coming Soon)`,
			'multiple_stores': $localize`:@@ts.plan.features.multiple_stores: Multiple stores (Coming Soon)`,
		},
		"other": {
			'premium_support': $localize`:@@ts.plan.features.premium_support: Premium Support`,
		}
	},
	"signup": {
		"invoicing": $localize`:@@ts.preferred_team_features.invoicing: Invoicing`,
		"online_store": $localize`:@@ts.preferred_team_features.online_store: Online Store`,
		"invoicing_online_store": $localize`:@@ts.preferred_team_features.invoicing_online_store: Invoicing and Online Store`,
		"food_beverage_ordering": $localize`:@@ts.preferred_team_features.food_beverage_ordering: Food & Beverage Ordering`,
		'completed': $localize`:@@ts.signup.completed:Signup completed successfully`,
	},
	"select_appropriate_image_size": (width: string, height: string) => {
		// return $localize`:@@ts.general.select_appropriate_image_size:Please select image in ${width} X ${height} size`;
		let msg = $localize`:@@ts.general.select_appropriate_image_size:Please select image in #WIDTH# X #HEIGHT# size`;
		msg = msg.replace('#WIDTH#', width).replace('#HEIGHT#', height);

		return msg;
	},
	"select2": {
		messages: function () {
			return {
				errorLoading: function () {
					return $localize`:@@select2.errorLoading:The results could not be loaded.`;
				},
				inputTooShort: function (args) {
					var remainingChars = args.minimum - args.input.length;
					var message = $localize`:@@select2.inputTooShort:Please enter # or more characters`;
					return message.replace('#', '' + remainingChars);
				},
				loadingMore: function () {
					return $localize`:@@select2.loadingMore:Loading more results…`;
				},
				noResults: function () {
					return $localize`:@@select2.noResults:No results found`;
				},
				searching: function () {
					return $localize`:@@select2.searching:Searching…`;
				}
			}
		}
	},
	"orders": {
		"tracking_orders": {
			'time_delivery': $localize`:@@ts.orders.tracking_orders.time_delivery: Estimated delivery`
		},
	},
	"zatca": {
		"certificate_generated_successfully": $localize`:@@ts.zatca.certificate_generated_successfully: Certificate generated successfully`
	},
	"customer":{
		"signin":{
			'success':$localize`:@@ts.customer.signin.success: Login successful!`
		},
		"signup":{
			'success':$localize`:@@ts.customer.signup.success: Signup successful!`
		},
		"forgot_password":{
			'success':$localize`:@@ts.customer.forgot_password.success: Password changed successfully!`
		},
		"error":{
			"all_field": $localize`:@@ts.customer.error.all_field: Please fill all required fields correctly.`
		}
	},
	getError: function (err) {
		let errKey = err.error && err.error.message ? err.error.message : (err.message ? err.message : null);

		if (errKey) {
			let msg = extractObjectValue(messages, errKey)
			return msg ? msg : errKey;
		} else {
			return messages.request_failed;
		}

	},
	t: function (key: string, defaultValue: string) {
		let msg = extractObjectValue(messages, key)
		return msg ? msg : defaultValue;
	}
};